var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100vh","width":"100vw"}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.refreshPosition}},[_vm._v("\n    实时点位\n  ")]),_c('div',{attrs:{"id":"amapcontainer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }